import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "children-detail-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "nav nav-tabs mb-3" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "child-info-part-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Профиль ребенка", -1)),
    (_ctx.childProfileInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, "ИИН ребенка:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.childIin), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[1] || (_cache[1] = _createElementVNode("strong", null, "ФИО ребенка:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.childFio), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "ИИН родителя:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.parentIin), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "ФИо родителя:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.parentFio), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Временный адрес ребенка:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.childTemporaryAddress), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Постоянный адрес ребенка:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.childFixedAddress), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Временный адрес родителя:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.parentTemporaryAddress), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Постоянный адрес родителя:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.childProfileInfo.parentFixedAddress), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "Загрузка...")),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: `/children/${_ctx.childId}/kindergartens`,
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" Данные об образовании в ДО ")
          ])),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: `/children/${_ctx.childId}/payments`,
          class: "nav-link"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode(" Оплаты ")
          ])),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: `/children/${_ctx.childId}/timesheets`,
          class: "nav-link"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" Табели ")
          ])),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_view)
    ])
  ]))
}